export enum GameState {
  PendingInvite,
  OurGame,
  OtherGame,
}

export interface GameStateConfig {
  textColor: string;
  buttonText: string;
  gradientClasses: string;
  icon: React.ReactNode;
}
